import { useSetAtom } from "jotai";
import type { FunctionComponent } from "react";

import { yieldToMain } from "shared/lib/utils";

import { contentShareWidgetDrawerAtom } from "scmp-app/components/content/content-share-widget-drawer/atoms";
import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";

import { StyledIconContainer, StyledIconShare } from "./styles";

export type HeaderFeaturesShareProps = {
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  showOnSwap?: SwapCondition;
};

export const HeaderFeaturesShare: FunctionComponent<HeaderFeaturesShareProps> = ({
  shouldSwap,
  showIn,
  showOnSwap,
}) => {
  const setContentShareWidgetDrawerState = useSetAtom(contentShareWidgetDrawerAtom);

  return (
    <StyledIconContainer $shouldSwap={shouldSwap} $showIn={showIn} $showOnSwap={showOnSwap}>
      <StyledIconShare
        onClick={() => {
          void (async () => {
            await yieldToMain({ priority: "user-blocking" });
            setContentShareWidgetDrawerState(state => ({ ...state, isOpen: true }));
          })();
        }}
      />
    </StyledIconContainer>
  );
};

HeaderFeaturesShare.displayName = "HeaderFeaturesShare";
